;(function () {
  'use strict'

  angular.module('contrast.log-enhancer').factory(
    'logEnhancerService',
    // eslint-disable-next-line angular/di-unused
    function logEnhancerServiceFactory(
      ServiceUtils,
      GlobalService,
      FeaturesService,
      LanguagesService,
      logEnhancerApiConfig,
      AGENT_FEATURE
    ) {
      'ngInject'

      return {
        getLogEnhancer: getLogEnhancer,
        getLogEnhancers: getLogEnhancers,
        toggleEnabled: toggleEnabled,
        addLogEnhancer: addLogEnhancer,
        editLogEnhancer: editLogEnhancer,
        deleteLogEnhancer: deleteLogEnhancer,
        getValidLanguages: getValidLanguages,
        getQuickFilters: getQuickFilters
      }

      /**
       * @param logId
       * @returns {Promise}
       */
      function getLogEnhancer(logId) {
        return logEnhancerApiConfig
          .getLogEnhancer(logId)
          .then(ServiceUtils.handleResolve('data.log'))
          .catch(ServiceUtils.handleError)
      }

      function getLogEnhancers(filters) {
        return logEnhancerApiConfig
          .getLogEnhancers(filters)
          .then(ServiceUtils.handleResolve('data'))
          .catch(ServiceUtils.handleError)
      }

      /**
       * @param logId
       * @param environment
       * @returns {Promise}
       */
      function toggleEnabled(logId, environment) {
        return logEnhancerApiConfig
          .toggleEnabled(logId, environment)
          .then(
            ServiceUtils.handleResolve('data', {
              log: ServiceUtils.LOGGER.SUCCESS
            })
          )
          .catch(ServiceUtils.handleError)
      }

      /**
       * @param {{}} settings
       * @returns {Promise}
       */
      function addLogEnhancer(settings) {
        return logEnhancerApiConfig
          .addLogEnhancer(settings)
          .then(
            ServiceUtils.handleResolve('data', {
              log: ServiceUtils.LOGGER.SUCCESS
            })
          )
          .catch(ServiceUtils.handleError)
      }

      /**
       * @param logId
       * @param settings
       * @returns {Promise}
       */
      function editLogEnhancer(logId, settings) {
        return logEnhancerApiConfig
          .editLogEnhancer(logId, settings)
          .then(
            ServiceUtils.handleResolve('data', {
              log: ServiceUtils.LOGGER.SUCCESS
            })
          )
          .catch(ServiceUtils.handleError)
      }

      function deleteLogEnhancer(logId) {
        return logEnhancerApiConfig
          .deleteLogEnhancer(logId)
          .then(
            ServiceUtils.handleResolve('data', {
              log: ServiceUtils.LOGGER.SUCCESS
            })
          )
          .catch(ServiceUtils.handleError)
      }

      function getValidLanguages() {
        return FeaturesService.getEnabledLanguagesByAgentFeature(
          AGENT_FEATURE.LOG_ENHANCERS
        ).then(function (languages) {
          return _.map(languages, function (lang) {
            return lang[0]
          })
        })
      }

      function getQuickFilters(filters) {
        return logEnhancerApiConfig
          .getQuickFilters(filters)
          .then(ServiceUtils.handleResolve('data.filters'))
          .catch(ServiceUtils.handleError)
      }
    }
  )
})()
